import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=fd2995b8&scoped=true"
import script from "./emailTemplate.vue?vue&type=script&lang=js"
export * from "./emailTemplate.vue?vue&type=script&lang=js"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=fd2995b8&prod&lang=scss"
import style1 from "./emailTemplate.vue?vue&type=style&index=1&id=fd2995b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2995b8",
  null
  
)

export default component.exports